export {ConfidenceScoreBlock} from 'modules/decisionsNext/components/BaseFilter/Dialog/components/ConfidenceScoreBlock/ConfidenceScoreBlock';
